import React from 'react';
import { CloudUpload32 } from '@carbon/icons-react';
import Styled from './Styled';
const UploadZone = ({ text, hint, hideAnchorIcon, ...props }) => (React.createElement(Styled.Dragger, Object.assign({}, props, { "$hideAnchorIcon": !!hideAnchorIcon }),
    React.createElement("p", { className: 'ant-upload-drag-icon' },
        React.createElement(CloudUpload32, null)),
    text && React.createElement("p", { className: 'ant-upload-text' }, text),
    hint && React.createElement("div", { className: 'ant-upload-hint' }, hint)));
export default UploadZone;
